import { Component } from '@angular/core';
import { IonicPage, ModalController, NavController, ToastController, NavParams, AlertController, ViewController } from 'ionic-angular';
import { RestProvider } from '../../providers/rest/rest';
import { DataProvider } from '../../providers/data/data';
import { HttpClient} from '@angular/common/http';

@IonicPage()
@Component({
  selector: 'page-userRequest',
  templateUrl: 'userRequest.html',
})
export class UserRequestPage {
  private userId: any;
  private date: any;
  private type: any;
  private companyId: any;
  private TimeCard = [];
  private Dates = [];
  private Requests = [];
  disabled: boolean = false;
  private tid: any;
  private id: any;
  private requestInput = [];
  private requestInput1 = [];

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private modalCtrl: ModalController,
    public alertCtrl: AlertController,
    private rest: RestProvider,
    private data: DataProvider,
    private toastCtrl: ToastController,
    public httpClient: HttpClient,
    ) {
  }
  ionViewDidEnter(): void {
    document.getElementById('mainmenu').style.visibility = 'visible';
    document.getElementById('backmenu').style.display = 'block';
    document.getElementById('mainHeader').style.display = 'block';
    document.getElementById('backFrom').innerText = '';
    this.data.currentTabName = 'Хүсэлтийн дэлгэрэнгүй';
  }
  ionViewDidLoad() {
    this.companyId = this.data.companyId;
    this.userId = this.data.userId;
    const now = new Date();
    let nowdate = now.getFullYear().toString() + '-' +
        ('0' + (now.getMonth() + 1).toString()).slice(-2) + '-' +
        ('0' + now.getDate().toString()).slice(-2);
    let defYear = now.getFullYear();
    this.rest.Dates(this.companyId).subscribe(res => {
      this.Dates = res;
      for(let i = 0; i < this.Dates.length;i++) {
        if(this.Dates[i].begin_day <= nowdate && this.Dates[i].end_day >= nowdate) {
          this.date = this.Dates[i].id;
        }
      }
      this.getTimeCard();
    });

  }

  getTimeCard() {
    this.rest.TimeCard(this.userId, this.date, this.companyId).subscribe(res => {
      this.TimeCard = res;
      this.type = 1;
      this.adminRequest_sent();
    });
  }

  getHuselt(event: any){
    this.type = event;
    this.adminRequest_sent();
  }

  adminRequest_sent(){
    this.rest.GetRequest(this.data.userId, this.date, this.type).subscribe(res => {
      this.Requests = res;
    });
  }

  updateReq(tid: any, index: any){
    if(this.requestInput1[index] == null){
      this.showToast1('Тайлбар бичигдээгүй байна!!!');
    }
    if(this.requestInput1[index] != null){
      if(confirm('Та сэргээхдээ итгэлтэй байна уу?')) {
        this.rest.updateRequest(tid, this.requestInput1[index], 'sergeeh').subscribe(res => {
          this.showToast('Таны сонгосон хүсэлтийг амжилттай сэргээлээ.');
          this.adminRequest_sent();
        });
      }
    }
  }
  agreeReg( request: any){
    let request_sent = this.modalCtrl.create(
      ModalAgainRequestPage,
      { request : request, timeCard: this.TimeCard },
      {
        showBackdrop: false,
        enableBackdropDismiss: true
      }
    );
    request_sent.present().catch(err => {

    });
    request_sent.onDidDismiss((data) => {
      if(data != null) {
        this.adminRequest_sent();
      }
    });
  }

  deleteReq(tid: any){
    if(confirm('Та устгахдаа итгэлтэй байна уу?')) {
      this.rest.deleteRequest(tid).subscribe(res => {
        this.showToast('Таны сонгосон хүсэлтийг амжилттай устгалаа.');
        this.adminRequest_sent();
      });
    }
  }

  setReq(request: any) {
    let request_sent = this.modalCtrl.create(
      ModalSetPage,
      { request : request, timeCard: this.TimeCard },
      {
        showBackdrop: false,
        enableBackdropDismiss: true
      }
    );
    request_sent.present().catch(err => {

    });
    request_sent.onDidDismiss((data) => {
      if(data != null) {
        this.adminRequest_sent();
      }
    });
  }
  onSelectClicked(value) {
    setTimeout(() => {
      document.getElementsByClassName('alert-radio-group')[0]
              .querySelector('[aria-checked="true"]')
              .scrollIntoView();
    }, 500);
  }

  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-success"
    });
    toast.present();
  }
  showToast1(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }
}

@Component({
  template: `
  <ion-header text-center style="height: 50px; text-align: center; background-color: #84dac8;">
    <ion-title>Хүсэлт илгээх</ion-title>
  </ion-header>

  <ion-content text-center>
    <ion-grid>

      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
          <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
            <ion-list radio-group>
            <ion-item>
                    <ion-label floating>Хүсэлтийн төрөл</ion-label>
                    <ion-select name="request" [(ngModel)]="type" (ionChange)="setHuselt($event)" [disabled]="type">
                      <ion-option *ngFor="let request of TimeCard.time_types" value="{{request.id}}">{{request.name}}</ion-option>
                    </ion-select>
            </ion-item>
            </ion-list>
          </ion-col>
          <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
          <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
            <ion-item>
              <ion-label *ngIf="type == 2 || type == 3">Эхлэх огноо</ion-label><ion-label *ngIf="type == 1 || type == 4">Огноо</ion-label>
              <ion-datetime displayFormat="YYYY/MM/DD" [(ngModel)]="sdate"></ion-datetime>
          </ion-item>
          </ion-col>
          <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
        </ion-row>

        <ion-row *ngIf="type == 2 || type == 3">
          <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
          <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
            <ion-item>
              <ion-label>Дуусах огноо</ion-label>
              <ion-datetime displayFormat="YYYY/MM/DD" [(ngModel)]="edate"></ion-datetime>
          </ion-item>
          </ion-col>
          <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
        </ion-row>

        <ion-row *ngIf="type == 2">
          <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
          <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-list  radio-group [(ngModel)]="ttype">
            <ion-item>
              <ion-label>AM</ion-label>
              <ion-radio value="AM" checked="true"></ion-radio>
            </ion-item>
            <ion-item>
              <ion-label>PM</ion-label>
              <ion-radio value="PM"></ion-radio>
            </ion-item>
          </ion-list>
          </ion-col>
          <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
        </ion-row>


        <ion-row *ngIf="type == 2">
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
        <ion-list  radio-group [(ngModel)]="salary">
          <ion-item>
            <ion-label>Цалингүй</ion-label>
            <ion-radio value="N" checked="true"></ion-radio>
          </ion-item>
          <ion-item>
            <ion-label>Цалинтай</ion-label>
            <ion-radio value="Y"></ion-radio>
          </ion-item>
        </ion-list>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>

        <ion-row *ngIf="type == 4">
          <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
          <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
            <ion-item>
              <input type="time" class="without_ampm" [(ngModel)]="time"/>
          </ion-item>
          </ion-col>
          <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
          <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
            <ion-item>
              <ion-label floating>Тайлбар</ion-label>
              <ion-textarea [(ngModel)]="desc"></ion-textarea>
            </ion-item>
          </ion-col>
          <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
          <ion-col text-center col-sm-3 col-xl-3 col-md-3 col-lg-3>
            <ion-item>
              <button class="myButton" (click)="sentRequest()">Илгээх</button>
            </ion-item>
          </ion-col><ion-col text-center col-sm-3 col-xl-3 col-md-3 col-lg-3>
            <ion-item>
              <button class="myButton" (click)="backto()">Буцах</button>
            </ion-item>
          </ion-col>
          <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
        </ion-row>
  </ion-grid>
</ion-content>
  `
})

export class  ModalAgainRequestPage {
  private sdate: any;
  private edate: any;
  private type: any;
  private ttype = 'AM';
  private time = '18:00';
  private desc: any;
  private request: any;
  private time_types = [];
  private TimeCard = [];
  private data: any;
  private tid: any;
  private value: any;
  private salary: any;
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    private rest: RestProvider,
    public httpClient: HttpClient,
    private viewCtrl: ViewController,
    private toastCtrl: ToastController)
  {
    this.request = this.navParams.get('request');
    this.TimeCard = this.navParams.get('timeCard');
    this.type = this.request.type_id;
    this.sdate = this.request.forgot_date;
    this.edate = this.request.end_date;
    this.ttype = this.request.type_time;
    this.time = this.request.forgot_time;
    this.salary = this.request.is_salary;
  }

  sentRequest(){
    if(this.desc == null){
      this.showToast1('Тайлбар бичигдээгүй байна!!!');
    }
    if(this.desc != null){
      this.rest.userSetRequest(this.request.id, this.sdate, this.edate, this.ttype, this.type, this.time, this.desc , this.salary).subscribe(res => {
        if(res.msg == 'ok') {
          this.showToast('Таны сонгосон хүсэлтийг амжилттай илгээлээ.');
        } else {
          this.showToast1('Одоогоор ажиллахгүй.');
        }
      });
      this.viewCtrl.dismiss({data: 'ok'});
    }
  }

  backto(){
    this.viewCtrl.dismiss({});
  }

  setHuselt(event: any){
    this.type = event;
  }

  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-success"
    });
    toast.present();
  }
  showToast1(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }
}


@Component({
  template: `
  <ion-header text-center style="height: 50px; text-align: center; background-color: #84dac8;">
    <ion-title>Хүсэлт илгээх</ion-title>
  </ion-header>

  <ion-content text-center>
    <ion-grid>

      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
          <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
            <ion-list radio-group>
            <ion-item>
                    <ion-label floating>Хүсэлтийн төрөл</ion-label>
                    <ion-select name="request" [(ngModel)]="type" (ionChange)="setHuselt($event)" [disabled]="type">
                      <ion-option *ngFor="let request of TimeCard.time_types" value="{{request.id}}">{{request.name}}</ion-option>
                    </ion-select>
            </ion-item>
            </ion-list>
          </ion-col>
          <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
          <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
            <ion-item>
              <ion-label *ngIf="type == 2 || type == 3">Эхлэх огноо</ion-label><ion-label *ngIf="type == 1 || type == 4">Огноо</ion-label>
              <ion-datetime displayFormat="YYYY/MM/DD" [(ngModel)]="sdate"></ion-datetime>
          </ion-item>
          </ion-col>
          <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
        </ion-row>

        <ion-row *ngIf="type == 2 || type == 3">
          <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
          <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
            <ion-item>
              <ion-label>Дуусах огноо</ion-label>
              <ion-datetime displayFormat="YYYY/MM/DD" [(ngModel)]="edate"></ion-datetime>
          </ion-item>
          </ion-col>
          <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
        </ion-row>

        <ion-row *ngIf="type == 2">
          <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
          <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-list  radio-group [(ngModel)]="ttype">
            <ion-item>
              <ion-label>AM</ion-label>
              <ion-radio value="AM" checked="true"></ion-radio>
            </ion-item>
            <ion-item>
              <ion-label>PM</ion-label>
              <ion-radio value="PM"></ion-radio>
            </ion-item>
          </ion-list>
          </ion-col>
          <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
        </ion-row>


        <ion-row *ngIf="type == 2">
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
        <ion-list  radio-group [(ngModel)]="salary">
          <ion-item>
            <ion-label>Цалингүй</ion-label>
            <ion-radio value="N" checked="true"></ion-radio>
          </ion-item>
          <ion-item>
            <ion-label>Цалинтай</ion-label>
            <ion-radio value="Y"></ion-radio>
          </ion-item>
        </ion-list>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>

        <ion-row *ngIf="type == 4">
          <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
          <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
            <ion-item>
              <input type="time" class="without_ampm" [(ngModel)]="time"/>
          </ion-item>
          </ion-col>
          <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
          <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
            <ion-item>
              <ion-label floating>Тайлбар</ion-label>
              <ion-textarea [(ngModel)]="desc"></ion-textarea>
            </ion-item>
          </ion-col>
          <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
          <ion-col text-center col-sm-3 col-xl-3 col-md-3 col-lg-3>
            <ion-item>
              <button class="myButton" (click)="sentRequest()">Илгээх</button>
            </ion-item>
          </ion-col><ion-col text-center col-sm-3 col-xl-3 col-md-3 col-lg-3>
            <ion-item>
              <button class="myButton" (click)="backto()">Буцах</button>
            </ion-item>
          </ion-col>
          <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
        </ion-row>
  </ion-grid>
</ion-content>
  `
})

export class  ModalSetPage {
  private sdate: any;
  private edate: any;
  private type: any;
  private ttype = 'AM';
  private time = '18:00';
  private desc: any;
  private request: any;
  private time_types = [];
  private TimeCard = [];
  private data: any;
  private tid: any;
  private value: any;
  private salary: any;
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    private rest: RestProvider,
    public httpClient: HttpClient,
    private viewCtrl: ViewController,
    private toastCtrl: ToastController)
  {
    this.request = this.navParams.get('request');
    this.TimeCard = this.navParams.get('timeCard');
    this.type = this.request.type_id;
    this.sdate = this.request.forgot_date;
    this.edate = this.request.end_date;
    this.ttype = this.request.type_time;
    this.time = this.request.forgot_time;
    this.salary = this.request.is_salary;
  }

  sentRequest(){
    if(this.desc == null){
      this.showToast1('Тайлбар бичигдээгүй байна!!!');
    }
    if(this.desc != null){
      this.rest.userSetRequest(this.request.id, this.sdate, this.edate, this.ttype, this.type, this.time, this.desc , this.salary).subscribe(res => {
        if(res.msg == 'ok') {
          this.showToast('Таны сонгосон хүсэлтийг амжилттай илгээлээ.');
        } else {
          this.showToast1('Одоогоор ажиллахгүй.');
        }
      });
      this.viewCtrl.dismiss({data: 'ok'});
    }
  }

  backto(){
    this.viewCtrl.dismiss({});
  }

  setHuselt(event: any){
    this.type = event;
  }

  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-success"
    });
    toast.present();
  }
  showToast1(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/userRequest/userRequest.ts